import React from "react";
import "../styles/Table.css";

export default function Table(props) {
  return (
    <div className="Table">
      <table>
        <thead>
          <tr>
            <th className="align-bottom p-0" scope="col">
              Description
            </th>
            <th className="align-bottom p-0" scope="col">
              Wind
            </th>
            <th className="align-bottom p-0" scope="col">
              Humidity
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="align-top p-0 description_val">
              {props.data.description}
            </td>
            <td className="align-top p-0 wind_val">{props.data.wind} km/h</td>
            <td className="align-top p-0 humidity_val">
              {props.data.humidity}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
